<div class="head-wrapper">
  <div class="head-title">{{ title }}</div>
</div>
